import { useQuery } from "@tanstack/react-query";

export interface TurnstileClientConfig {
  required: boolean;
  configured: boolean;
  siteKey?: string;
}

async function fetchTurnstileConfig(): Promise<TurnstileClientConfig> {
  const response = await fetch("/api/security/turnstile/config", {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to load verification settings");
  }

  return response.json();
}

export function useTurnstileConfig() {
  const query = useQuery({
    queryKey: ["/api/security/turnstile/config"],
    queryFn: fetchTurnstileConfig,
    staleTime: Infinity,
    retry: false,
  });

  return {
    ...query,
    required: query.data?.required ?? false,
    configured: query.data?.configured ?? false,
    siteKey: query.data?.siteKey,
    enabled: Boolean(query.data?.configured && query.data?.siteKey),
  };
}
